"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var FacebookPhotosDataSource =
/*#__PURE__*/
function () {
  function FacebookPhotosDataSource() {
    (0, _classCallCheck2["default"])(this, FacebookPhotosDataSource);
  }

  (0, _createClass2["default"])(FacebookPhotosDataSource, null, [{
    key: "getName",
    value: function getName() {
      return 'Facebook Photos';
    }
  }, {
    key: "getItemId",
    value: function getItemId(item) {
      return item.id;
    }
  }, {
    key: "mapResult",
    value: function mapResult(result) {
      var mappedImagesFromResult = result.albums.data.map(function (data) {
        return data.photos ? data.photos : {
          data: []
        };
      }).map(function (photos) {
        return photos.data;
      }).reduce(function (initial, next) {
        return [].concat((0, _toConsumableArray2["default"])(initial), (0, _toConsumableArray2["default"])(next));
      }, []).map(function (reduced) {
        return reduced.images[0];
      });
      var mappedResult = mappedImagesFromResult.map(function (item, index) {
        var image = {
          full_picture: item.source,
          value: item.source,
          width: item.width,
          height: item.height,
          noCdn: true
        };
        return {
          title: '',
          id: index,
          media: image,
          image: image
        };
      });
      return mappedResult;
    }
  }, {
    key: "getDataPromise",
    value: function getDataPromise(value, requestBody) {
      var item = [{
        id: 'accountId',
        value: value
      }, {
        id: 'photoLimit',
        value: 20
      }, {
        id: 'albumLimit',
        value: 10
      }];
      requestBody.item = item;
      return requestBody;
    }
  }]);
  return FacebookPhotosDataSource;
}();

FacebookPhotosDataSource.getRequestName = function () {
  return 'FacebookListPhotosApi';
};

var _default = FacebookPhotosDataSource;
exports["default"] = _default;